export const useAuthGetters = () => {
  return ref();
};
